
import { WerkzoekenFeedJobDto } from "../api/werkzoeken/types";

import type { DrawerSize } from "@/components/ui/v2/use-drawer";
import { createVacancyDrawerRowClickHandler } from "@/features/integrations/shared/utils/vacancyDrawerRowClick";

type RowClickOptions = {
  drawerTitle?: string;
  onError?: () => void;
};

/**
 * Creates a row click handler for Werkzoeken jobs that opens a vacancy drawer.
 * Delegates to the generic vacancy drawer handler with Werkzoeken-specific ID extraction.
 */
export function createWerkzoekenRowClickHandler(
  clientId: string | undefined,
  openDrawer: (content: React.ReactNode, title: string, size?: DrawerSize) => void,
  options?: RowClickOptions
): (row: unknown) => Promise<void> {
  if (!clientId) {
    return async () => {};
  }

  return createVacancyDrawerRowClickHandler(clientId, openDrawer, {
    getRowId: (row) => (row as WerkzoekenFeedJobDto).id,
    drawerTitle: options?.drawerTitle,
    onError: options?.onError,
  });
}
